		/**
		 * @ngdoc service
		 * @constructor
		 * @name WebCoreModule.service:WcCameraService
		 * @requires $window
		 * @requires $rootScope
		 * @requires $window
		 * @description
		 * The WcCameraService service is used for taking pictures from user's camera for uploading the image to the application.
		 *
		 * To leverage the WcCameraService, create a new instance using 'new WcCameraService()' in calling code.
		 * The WcCameraService constructor creates a new instance of the WcCameraService. This prototype
		 * establishes the necessary properties and functions for taking pictures from camera.
		 */


angular.module('WebCoreModule')
	.service('WcCameraService', ['$window', '$rootScope', 'WcImageFileService',
		function($window, $rootScope, WcImageFileService) {
			var navigator = $window.navigator;

			//Events to ensure Webcam is disengaged when navigated away.
			$rootScope.$on('$stateChangeStart', angular.bind(this, function() {
				this.stopCamera();
			}));

			$window.onbeforeunload = angular.bind(this, function() {
				this.stopCamera();
			});

			this.cameraIsOn = false;
			this.height = 0;
			this.width = 0;

			this.setCameraSize = function(x, y) {
				this.height = y;
				this.width = x;
			};

			// WebcamJS's solution for finding the correct getUserMedia function
			// https://github.com/jhuckaby/webcamjs/blob/master/webcam.js
			this.mediaDevices = (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ?
				navigator.mediaDevices : ((navigator.mozGetUserMedia || navigator.webkitGetUserMedia) ? {
				getUserMedia: function(c) {
					// TODO use $q
					return new Promise(function(y, n) {
						(navigator.mozGetUserMedia ||
						navigator.webkitGetUserMedia).call(navigator, c, y, n);
					});
				}
			} : null);
			//end webcamjs

			// Only for testing. We have yet to find out how to mock document.createElement without
			// blowing up angular-mock. We have a Stack Overflow question out there to hopefully
			// find an answer.
			//
			// TODO: try $document instead of document
			// http://stackoverflow.com/questions/35369629/using-jasmine-to-spy-on-document-createelement-throws-error-from-angular-mock
			//
			this.generateVideo = function() {
				return document.createElement('video');
			};

			// https://github.com/jhuckaby/webcamjs/blob/master/webcam.js
			this.returnVideoElement = function() {
				// We don't use jQuery for the video element because you must call the play() function
				// on the actual HTML element, not a jquery object.
				this.videoElement = this.generateVideo();
				this.videoElement.setAttribute('autoplay', 'autoplay');
				this.videoElement.style.width = '' + this.width + 'px';
				this.videoElement.style.height = '' + this.height + 'px';

				return this.mediaDevices.getUserMedia({
					audio: false,
					video: true
				}).then(angular.bind(this, function(stream) {
					this.stream = stream;
					this.videoElement.src = $window.URL.createObjectURL(stream);

					return $(this.videoElement);
				})).catch(function(error) {
					console.error(error);
				});
			};
			//end webcamjs

			/**
			 * @ngdoc method
			 * @name WcCameraService.checkForCamera
			 * @methodOf WebCoreModule.service:WcCameraService
			 * @returns {Promise} The data retrieved from the backing service wrapped in a promise.
			 * @description
			 * The WcCameraService provides a checkForCamera function to check the availability of the user's camera.
			 */
			this.checkForCamera = function() {
				return $window.navigator.mediaDevices.enumerateDevices()
					.then(function(devices) {
						devices = devices.filter(function(device) {
							return device.kind === 'videoinput';
						});

						return (devices.length > 0);
					})
					.catch(function(err) {
						console.log(err.name + ": " + err.message);
					});
			};

			/**
			 * @ngdoc method
			 * @name WcCameraService.takePicture
			 * @methodOf WebCoreModule.service:WcCameraService
			 * @returns {Object} The data retrieved from the backing service will be an image in jpeg format.
			 * @description
			 * The WcCameraService provides a takePicture function to take the picture from user's camera.
			 */

			this.takePicture = function() {
				var canvas = WcImageFileService.generateCanvas();
				canvas.width = this.width;
				canvas.height = this.height;

				var context = canvas.getContext('2d');
				context.drawImage(this.videoElement, 0, 0, this.width, this.height);

				return canvas.toDataURL('image/jpeg', 100);
			};

			/**
			 * @ngdoc method
			 * @name WcCameraService.startCamera
			 * @methodOf WebCoreModule.service:WcCameraService
			 * @description
			 * The WcCameraService provides an stopCamera function to start the camera.
			 */
			this.startCamera = function() {
				this.videoElement.play();
				this.cameraIsOn = true;
			};

			/**
			 * @ngdoc method
			 * @name WcCameraService.stopCamera
			 * @methodOf WebCoreModule.service:WcCameraService
			 * @description
			 * The WcCameraService provides an stopCamera function to stop the camera.
			 */
			this.stopCamera = function() {
				if(this.cameraIsOn) {
					// https://github.com/jhuckaby/webcamjs/blob/master/webcam.js
					if (this.stream.getVideoTracks) {
						// get video track to call stop on it
						var tracks = this.stream.getVideoTracks();
						if (tracks && tracks[0] && tracks[0].stop) {
							tracks[0].stop();
						}
					} else if (this.stream.stop) {
						// deprecated, may be removed in future
						this.stream.stop();
					}
					//end webcamjs

					this.cameraIsOn = false;
				}
			};
		}
	]);